export enum LOCAL_STORAGE {
  uuid = 'deviceUuid',
  fcmToken = 'fcmToken',
  property = 'activeProperty',
  lastNotification = 'lastNotificationAlerted',
  betaUser = 'isBetaUser',
}
